import { IAutomationBlueprint } from './Automation';

export enum AutomationSignalType {
  UPDATE_EXECUTION = 'UPDATED_EXECUTION',
}

export interface IAutomationSignalParams {
  blueprint: IAutomationBlueprint;
}
